import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import CameraDevice from './camera-device';
import CameraDeviceUpdate from './camera-device-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={CameraDeviceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={CameraDeviceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/activate`} component={CameraDeviceUpdate} />
      <ErrorBoundaryRoute path={match.url} component={CameraDevice} />
    </Switch>
  </>
);

export default Routes;
